import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  config: null,
  getConfigStatus: IDLE,
  updateConfigStatus: IDLE
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    getConfig(state) {
      state.getConfigStatus = LOADING;
    },
    getConfigSucceeded(state, action) {
      state.config = action.payload;
      state.getConfigStatus = SUCCEEDED;
    },
    getConfigFailed(state) {
      state.getConfigStatus = FAILED;
    },

    updateConfig(state) {
      state.updateConfigStatus = LOADING;
    },
    updateConfigSucceeded(state, action) {
      state.config = action.payload;
      state.updateConfigStatus = SUCCEEDED;
    },
    updateConfigFailed(state) {
      state.updateConfigStatus = FAILED;
    },

    updateConfigOnboardingSettings(state) {
      state.updateConfigStatus = LOADING;
    },
    updateConfigOnboardingSettingsSucceeded(state, action) {
      state.config = action.payload;
      state.updateConfigStatus = SUCCEEDED;
    },
    updateConfigOnboardingSettingsFailed(state) {
      state.updateConfigStatus = FAILED;
    }
  }
});

export const {
  getConfig,
  getConfigSucceeded,
  getConfigFailed,
  updateConfig,
  updateConfigSucceeded,
  updateConfigFailed,
  updateConfigOnboardingSettings,
  updateConfigOnboardingSettingsSucceeded,
  updateConfigOnboardingSettingsFailed
} = configSlice.actions;

export default configSlice.reducer;
